import { API } from 'aws-amplify';

export const listScoringRequests = async (userId) => API.post('AllLoans', '/', { body: { userId } })
  .catch((error) => {
    console.log('Error in getAllLoans (error.response):', error.response); // eslint-disable-line no-console
    console.error('Error in getAllLoans:', error); // eslint-disable-line no-console
  });

export const getScoringRequest = async (clientId, loanId) => API.post('SingleLoan', '/', { body: { clientId, loanId } })
  .catch((error) => {
    console.error('Error in getSingleLoan:', error); // eslint-disable-line no-console
    console.error('Error in getSingleLoan (response):', error.response); // eslint-disable-line no-console
  });

export const getReferenceFromInvite = (inviteId, requestId, ref) => API.post(
  'InviteReference',
  '/',
  { body: { inviteId, requestId, ref } },
);
